var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCfd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5167_9826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6144 15.549H6.60563C6.29582 15.549 5.9987 15.4259 5.77964 15.2069C5.56057 14.9878 5.4375 14.6907 5.4375 14.3809V5.03586C5.4375 4.72606 5.56057 4.42894 5.77964 4.20987C5.9987 3.99081 6.29582 3.86774 6.60563 3.86774H13.6144C13.9242 3.86774 14.2213 3.99081 14.4404 4.20987C14.6594 4.42894 14.7825 4.72606 14.7825 5.03586V14.3809C14.7825 14.6907 14.6594 14.9878 14.4404 15.2069C14.2213 15.4259 13.9242 15.549 13.6144 15.549ZM6.60563 5.03586V14.3809H13.6144V5.03586H6.60563Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10126 14.3808H0.765015V13.2127H3.10126V6.20395H0.765015V5.03583H3.10126C3.41107 5.03583 3.70819 5.1589 3.92725 5.37796C4.14632 5.59703 4.26939 5.89415 4.26939 6.20395V13.2127C4.26939 13.5225 4.14632 13.8196 3.92725 14.0387C3.70819 14.2578 3.41107 14.3808 3.10126 14.3808Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4551 14.3808H17.1188C16.809 14.3808 16.5119 14.2578 16.2928 14.0387C16.0738 13.8196 15.9507 13.5225 15.9507 13.2127V6.20395C15.9507 5.89415 16.0738 5.59703 16.2928 5.37796C16.5119 5.1589 16.809 5.03583 17.1188 5.03583H19.4551V6.20395H17.1188V13.2127H19.4551V14.3808Z",
    fill: "#F6F6F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5167_9826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.69,
    height: 18.69,
    fill: "white",
    transform: "translate(0.765015 0.363342)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfd);
export default __webpack_public_path__ + "static/media/cfd.63836e406da6978b44c7be46ea7e6f5d.svg";
export { ForwardRef as ReactComponent };